export const FORM_FIELDS = [
  {
    label: "Straight",
    name: "straight",
    value: "straight",
    isChecked: true
  },
  {
    label: "Gay",
    name: "gay",
    value: "gay",
    isChecked: true
  },
  {
    label: "Lesbian",
    name: "lesbian",
    value: "lesbian",
    isChecked: true
  },
  {
    label: "Trans",
    name: "trans",
    value: "trans",
    isChecked: true
  },
  {
    label: "Animated",
    name: "animated",
    value: "animated",
    isChecked: true
  },
  {
    label: "Bisexual",
    name: "bisexual",
    value: "bisexual",
    isChecked: true
  },
];
